window.addEventListener('DOMContentLoaded', () => {
    const iframe = document.getElementById('delving-collections');
    const offset = 32;

    function resizeIframe() {
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document;
            if (doc?.body) {
                const height = doc.body.scrollHeight;
                iframe.style.height = height + offset + 'px';
            }
        } catch (e) {
            console.warn('Could not access iframe content for resizing:', e);
        }
    }

    if (iframe) {
        iframe.addEventListener('load', () => {
            resizeIframe();

            const doc = iframe.contentDocument || iframe.contentWindow.document;
            if (doc?.body) {
                const observer = new MutationObserver(resizeIframe);
                observer.observe(doc.body, { attributes: true, childList: true, subtree: true });
            }

            setTimeout(resizeIframe, 300);
        });
    }
});
